import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';

export const MuiFormLabel: {
    styleOverrides: ComponentsOverrides<Theme>['MuiFormLabel'];
    defaultProps?: ComponentsProps['MuiFormLabel'];
} = {
    styleOverrides: {
        root: {
            color: 'inherit',
        },
    },
};
